import apiFetch from '../apiFetch'

export default function (filtros, token) {
  return apiFetch({endPoint: `Informes/getImprimirInformePersonalizado`, method: 'POST', body: filtros, token: token})
}